import { FirebaseDocChangeType, FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { StoreShippingType } from 'types/storeShipping'
import { mergeListeningStoreShippings } from 'reducks/storeShipping/operations'
import { setStoreShippingUnsubscribesAction } from 'reducks/storeShipping/actions'

const fetchStoreShippings = (date: string, storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // リスナーが設定済み（unsubscribeがセットされている）であればスキップ（二重取得の防止）
    if (getState().storeShipping.is_set_unsubscribe) return
    const unsubscribe = await storeRef
      .collection('store_shippings')
      .where('scheduled_delivery_date', '==', date)
      .orderBy('shipping_number', 'asc')
      .onSnapshot((snapshots) => {
        // データの追加のみ監視する
        const changes = snapshots.docChanges().filter((change: FirebaseDocChangeType) => change.type === 'added')
        const currentStoreShippings: StoreShippingType[] = getState().storeShipping.shippings
        mergeListeningStoreShippings(changes, currentStoreShippings, dispatch)
      })
    dispatch(setStoreShippingUnsubscribesAction([unsubscribe]))
  }
}

export default fetchStoreShippings
